module.exports = ".subtitle{\r\n    margin: 20px -15px 5px;\r\n  }\r\n    \r\n    .btn{\r\n      width:100px;\r\n    }\r\n    \r\n    .row:nth-child(odd){\r\n      background: #f3f3f3;\r\n      padding-top: 10px;\r\n    }\r\n    \r\n    .row:nth-child(even){     \r\n      padding-top: 10px;\r\n    }\r\n    \r\n    .error-msg{\r\n        margin-top:-5px;\r\n    \r\n    }\r\n    \r\n    .radio-inline{\r\n      margin: 0px 5px;\r\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/basic-registration/basic-registration.component.css
// module id = ./src/app/sainik-registration/basic-registration/basic-registration.component.css
// module chunks = main